var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-navigation',_vm._b({on:{"goto":_vm.goto,"goToDashboard":_vm.goToDashboard},scopedSlots:_vm._u([{key:"right",fn:function(){return [_c('main-navigation-mini-card',_vm._b({on:{"goto":_vm.goto,"showAdminOptions":function($event){return _vm.showAdminOptions($event)},"goBackToAccount":function($event){return _vm.goBackToAccount()}}},'main-navigation-mini-card',{
        user: _vm.user,
        adminOptions: _vm.adminOptions,
        isManager: _vm.isManager,
        isStylist: _vm.isStylist,
        isSuperuser: _vm.isSuperuser,
        username: _vm.username,
        name: _vm.name,
        fullName: _vm.fullName,
      },false))]},proxy:true}])},'main-navigation',{
    tabs: _vm.menuItems,
    current: _vm.currentRoute()
  },false))}
var staticRenderFns = []

export { render, staticRenderFns }